module.exports = __webpack_public_path__ + "static/img/status-success.eefd1a13.svg";